import {storeSelector} from "modules/utils";
import {createSelector} from "reselect";

export const getMessageBarState = storeSelector("messageBar");

export const getMessageBar = createSelector(
	getMessageBarState,
	(messageBar) => messageBar
);

export const getCurrentMessage = createSelector(
	getMessageBar,
	({currentMessage}) => currentMessage
);

export const getDismissedMessages = createSelector(
	getMessageBar,
	({dismissedMessages}) => dismissedMessages
);

export const isMessageDismissed = createSelector(
	getCurrentMessage,
	getDismissedMessages,
	({version}, dismissedMessages) => dismissedMessages.includes(version)
);
